/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersrequestsempty2Inputs */

const en_membersrequestsempty2 = /** @type {(inputs: Membersrequestsempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No open requests.`)
};

const de_membersrequestsempty2 = /** @type {(inputs: Membersrequestsempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine offenen Anfragen.`)
};

/**
* | output |
* | --- |
* | "No open requests." |
*
* @param {Membersrequestsempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersrequestsempty2 = /** @type {((inputs?: Membersrequestsempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersrequestsempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersrequestsempty2(inputs)
	return de_membersrequestsempty2(inputs)
});
export { membersrequestsempty2 as "membersRequestsEmpty" }